var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "aimo-panel" }, [
    _c("div", { staticClass: "aimo-panel-title" }, [
      _c("i", { staticClass: "fas fa-plug" }),
      _vm._v(" " + _vm._s(_vm.strings.connections) + "\n        "),
      _vm.manageUrl
        ? _c(
            "a",
            { staticClass: "manage-link", attrs: { href: _vm.manageUrl } },
            [_vm._v(_vm._s(_vm.strings.manage))]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "conn-list" },
      _vm._l(_vm.connections, function (conn) {
        return _c(
          "div",
          {
            key: conn.name,
            staticClass: "conn-item",
            class: { "is-disabled": !conn.active },
          },
          [
            _c("div", {
              staticClass: "conn-dot",
              class: { "is-active": conn.active },
            }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(conn.name))]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }